import React from 'react'
import single from './bookIMG/SingleRoom Selfcontain/single.jpg'
import ran from './bookIMG/Renajoe .Ejusu/r1.avif'
import Navbar from './Navbar'
import { useState,useEffect} from 'react'
import { useNavigate } from 'react-router-dom'
import Aos from 'aos'
import 'aos/dist/aos.css'
import { userContext } from '../App'
import { useContext } from 'react'
import Lottie from 'lottie-react'
import cat from './cat.json'
const Homstel = () => {
 
  useEffect(()=>{
    Aos.init({duration:2000})
  },[])



  const [offcampus,setoffcampus]=useState([
    {
      name:'Renajoe house',
      Price:'Ghc 600 - Ghc 2400',
      type:'Homestel',
      location:'Ejisu', 
      image:ran
    },
    {
      name:'1 bed room selfcontained',
      Price:'Ghc 1200 - Ghc 3000',
      type:'Homestel',
      location:'Ayeduasi', 
      image:single
    }
  ])
  const nav=useNavigate();
  const [search,hand,setsearch,location,setlocation,Locate,Kotei,Ayeduasi,Newsite,TechJunction,KNUSTCampus,Bomsu,Kumasi,price,setprice,main,price1,price2,price3,price4,price5,price6,price7,type,settype,types,Apartments,GuestHouse,homstel,Hostels,collapse,toggle,settoggle,toggler,arrow,setarrow, down,click,setclick,onpress]=useContext(userContext)

  return (
    <div>
      <Navbar />
      <div className='grid lg:grid-cols-4 md:mt-3 md:mx-3 mx-5 sm:justify-center rounded-md gap-6 md:grid-cols-3 mt-[100px]' style={{paddingTop:'10%'}}  >
    {offcampus.filter(items=>{
        const name=items.name.toLocaleLowerCase();
        const find=search.toLocaleLowerCase();
        if(name.startsWith(find)){
          return items
        }
    }

    ).filter((post)=>{
      const look=location.toLocaleLowerCase();
      const loc=post.location.toLocaleLowerCase(); 
      if(look=='location'){
        return post
      }
      if(loc.includes(look)){
        return post
      }

  }).length > 0? offcampus.filter((post)=>{
    const name=post.name.toLocaleLowerCase();
    const find=search.toLocaleLowerCase(); 
    
    if(find==''){
      return post
    }
    if(name.startsWith(find)){
      return post
    }
  })
  .filter((post)=>{
      const look=location.toLocaleLowerCase();
      const loc=post.location.toLocaleLowerCase(); 
      if(look=='location'){
        return post
      }
      if(loc.includes(look)){
        return post
      }

  }).filter((post)=>{
    const pro=post.Price
    const pr=price;
    if(pr=='price'){
      return post
    }
    if(pro.includes(pro)){
      return post
    }
  }
    
  ).map(post=><div data-aos='fade-right'>
      <img className='rounded-lg shadow-md hover:-translate-y-5 cursor-pointer' style={{width:'400px', height:'300px'}} src= {post.image} onClick={()=>{
        {if(post.image===ran){
          nav('ran');
        }
        if(post.image===single){
          nav('single');
        }
      }
      }} />
      <h2 className='font-bold from-neutral-950 font-serif uppercase' >{post.name} </h2>
      <div className='  text-gray-700 '>{post.type}</div>
      <div className=' text-red-700 '>{post.Price}</div>
      <div className=' text-gray-700 font-bold text-md'>{post.location}</div>
    </div>): <div className=' bg-gray-200 md:w-[1620px] md:-mx-8 md:-mt-[60px] -mt-[60px] w-[412px] -mx-5'>
    <div className=' md:w-[400px] md:ml-[500px] '>
      <Lottie animationData={cat}/>
      </div>
      <h3 className=' md:text-3xl text-2xl font-bold font-serif md:ml-[440px] md:-mt-[47px] ml-4 -mt-14'>Sorry we couldn't find your search. </h3>
      </div>}
      </div>
    </div>
  )
}

export default Homstel
